import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import get from 'lodash/get'

import MobilePreferencesForm from '../../components/settings/mobile-preferences-form'
import {
  loadMobilePreferences,
  updateMobilePreferences
} from '../../actions/settings'
import {
  fetchDevice
} from '../../actions/device'

const fields = [
  'servicingCompletions',
  'issues',
  'unsatisfactory'
]

const mapStateToProps = (state, props) => {
  const {
    servicingCompletions = false,
    issues = false,
    unsatisfactory = false
  } = get(state, 'settings.mobilePreferences', {})

  const userType = get(state.auth, 'session.type')
  const device = Object.values(get(state, 'device', {}))[0] || {}
  const { enabled = false } = device

  return {
    initialValues: {
      servicingCompletions,
      issues,
      unsatisfactory
    },
    enabled,
    userType
  }
}

const mapDispatchToProps = (dispatch, props) => {
  dispatch(fetchDevice())
  dispatch(loadMobilePreferences())

  return {
    onSubmit (data) {
      dispatch(updateMobilePreferences(data))
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'MobileNotificationPereferences'
  },
  mapStateToProps,
  mapDispatchToProps
)(MobilePreferencesForm)



// WEBPACK FOOTER //
// ./src/containers/settings/mobile-preferences-form-container.js